module.exports = __webpack_public_path__ + "static/media/coyotes-wallpaper.bb615150.jpg";